module.exports = __webpack_public_path__ + "media/images/home-promo-66f16638469dea97158cb076a542476c.jpg";